import styled from "styled-components";
import { Box, Typography } from "@mui/material";

interface ICardContainer {
	image?: string;
	filter?: number;
}

interface IRewardItem {
	width?: string;
	filter?: number;
}

interface IItems {
	isOffer?: boolean;
}

interface IDescription {
	variant?: string;
}

export const Container = styled.div<ICardContainer>`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	background-image: url(${(props) => props.image});
	filter: grayscale(0);
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	margin-top: 0.4em;
	position: relative;
	font-size: 0.9em;
	width: 24em;
	height: 13.13em;

	@media (min-width: 734px) {
		width: 31.7em;
		height: 18.1em;
	}
`;

export const DescriptionContainer = styled.div`
	height: 30%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Description = styled.div<IDescription>`
	color: #fff;
	text-shadow: 0 0.14em 0.21em rgba(0, 0, 0, 0.35);
	-webkit-text-stroke-width: 0.29em;
	-webkit-text-stroke-color: #593113;
	paint-order: stroke fill;
	font-weight: 400;
	font-family: Baloo;
	font-style: normal;
	z-index: 500;
	font-size: 1.4em;
	line-height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	@media (min-width: 734px) {
		font-size: 2em;
		text-shadow: 0 0.1em 0.15em rgba(0, 0, 0, 0.35);
		-webkit-text-stroke-width: 0.2em;
	}
`;

export const Items = styled.div<IItems>`
	justify-content: center;
	align-items: center;
	display: flex;
	z-index: 500;
	height: ${(props) => (props.isOffer ? "52%" : "61%")};
`;

export const RewardItem = styled.div<IRewardItem>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex-basis: ${(props) => props.width};
	box-sizing: border-box;
	padding: 0 0.4em;
	filter: grayscale(${(props) => props.filter});
`;

export const RewardAmount = styled(Typography)`
	color: #fff;
	font-weight: 700;
	font-family: Baloo;
	font-size: 1.31em;
	text-shadow: 0.15em 0.15em 0 #000;
	-webkit-text-stroke-width: 0.15em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;

	@media (min-width: 734px) {
		font-size: 2em;
		text-shadow: 0.1em 0.1em 0 #000;
		-webkit-text-stroke-width: 0.1em;
	}
`;

export const ItemImage = styled.img<{ loyaltyBoxExtraMessage?: boolean }>`
	width: ${(props) => (props.loyaltyBoxExtraMessage ? "2.44em" : "4.13em")};
	height: ${(props) => (props.loyaltyBoxExtraMessage ? "2.44em" : "4.13em")};
	object-fit: contain;
	justify-self: center;
	align-self: center;

	@media (min-width: 734px) {
		width: ${(props) => (props.loyaltyBoxExtraMessage ? "3.4em" : "4.53em")};
		height: ${(props) => (props.loyaltyBoxExtraMessage ? "3.4em" : "4.53em")};
	}
`;

export const LockIcon = styled.img`
	position: absolute;
	top: 30%;
	right: -7%;
	height: 75%;
	z-index: 1000;

	@media (min-width: 734px) {
		right: -9%;
	}
`;

export const InfoBox = styled(Box)<{ loyaltyBoxExtraMessage?: boolean }>`
	background-color: rgb(0 0 0 / 30%);
	border-radius: 999em;
	color: white;
	font-weight: 220;
	opacity: 0.9;
	padding: 0.3em 0.7em;
	position: absolute;
	background-repeat: no-repeat;

	padding-block: ${(props) =>
		props.loyaltyBoxExtraMessage ? "0.1em" : "0.3em"};
`;

export const LoyalBox = styled(InfoBox)`
	background-position: 90% center;
	color: white;
	padding-right: 2em;
	background-color: white;
	white-space: nowrap;

	> div {
		align-items: center;
		justify-content: center;
		display: flex;
		gap: 0.2em;
	}
`;

export const LoyalBoxWrap = styled(Box)<{ loyaltyBoxExtraMessage?: boolean }>`
	bottom: ${(props) => (props.loyaltyBoxExtraMessage ? "12%" : "9%")};
	display: flex;
	font-size: 0.5em;
	justify-content: center;
	position: relative;
`;
